import React, {Component} from 'react';
import {connect} from 'react-redux';
import './Login.css';
import queryString from 'query-string'

class Login extends Component {

    componentWillMount() {
    }

  componentDidMount() {
    const values = queryString.parse(this.props.location.search)
    this.handleLogin(values.token)
  }

    handleForgotPassword = () => {
      this.props.history.push("/admin/recovery");
    };

    handleLogin = (token) => {
      this.props.login({token});
    };

    render() {

      return (
        <div className="login">
          Processing authentication
        </div>
      )
    }
  }

const mapDispatchToProps = dispatch => ({
  login: (payload) => dispatch({type: 'LOGIN.REQUEST', payload}),
})

const mapStateToProps = state => ({
  authentication: state.authentication,
})



export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login)
